module.exports = __webpack_public_path__ + "static/media/03.fc6c51c8.jpg";